(function () {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  };

  ready(() => {
    const body = document.body;
    if (!body || !body.classList.contains('healthy-century-ui')) return;

    body.classList.add('hc-js-ready');

    const progress = document.createElement('div');
    progress.className = 'hc-scroll-progress';
    progress.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progress);

    const header = document.querySelector('.shopify-section-header-sticky, .section-header, sticky-header, .header-wrapper');
    const setHeaderState = () => {
      body.classList.toggle('hc-has-scrolled', window.scrollY > 18);
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const value = height > 0 ? Math.min(window.scrollY / height, 1) : 0;
      progress.style.transform = `scaleX(${value})`;
    };

    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });

    document.querySelectorAll('.card-wrapper, .objective-card, .support-block-card, .review, .nh-newsletter-hero, .product__media-item, .cart-item').forEach((item) => {
      item.classList.add('hc-reveal');
    });

    const revealItems = document.querySelectorAll('.hc-reveal');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      revealItems.forEach((item, index) => {
        item.style.setProperty('--hc-reveal-delay', `${Math.min(index % 8, 7) * 55}ms`);
        observer.observe(item);
      });
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    document.querySelectorAll('.card-wrapper, .objective-card, .button, .quick-add__submit').forEach((item) => {
      item.addEventListener('pointermove', (event) => {
        const rect = item.getBoundingClientRect();
        item.style.setProperty('--hc-pointer-x', `${event.clientX - rect.left}px`);
        item.style.setProperty('--hc-pointer-y', `${event.clientY - rect.top}px`);
      });
    });

    document.querySelectorAll('.product-form__submit, .quick-add__submit, .cart__checkout-button').forEach((button) => {
      button.addEventListener('click', () => {
        button.classList.remove('hc-pulse');
        window.requestAnimationFrame(() => button.classList.add('hc-pulse'));
      });
    });

    if (header) {
      header.classList.add('hc-modern-header');
    }
  });
})();
